// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var gridStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.gridParent': {
    width: "calc(100% + 24px)",
    marginLeft: "var(--ds-space-negative-150, -12px)",
    marginRight: "var(--ds-space-negative-150, -12px)",
    transform: 'scale(1)',
    zIndex: 2
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.gridContainer': {
    position: 'fixed',
    height: '100vh',
    width: '100%',
    pointerEvents: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.gridLine': {
    borderLeft: "1px solid ".concat("var(--ds-border, #091E4224)"),
    display: 'inline-block',
    boxSizing: 'border-box',
    height: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '-1px',
    transition: 'border-color 0.15s linear',
    zIndex: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.highlight': {
    borderLeft: "1px solid ".concat("var(--ds-border-focused, #388BFF)")
  }
});